import script from "./AtomImageUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtomImageUpload.vue?vue&type=script&setup=true&lang=ts"

import "./AtomImageUpload.vue?vue&type=style&index=0&id=79017614&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79017614"]])

export default __exports__